import { Navigate, Route, Routes } from 'react-router-dom';
import CRMDashboardPage from './CRMDashboardPage';
import PipelinePage from './PipelinePage';
import ContactsPage from './ContactsPage';
import ActivitiesPage from './ActivitiesPage';

export default function CRMRoutes() {
  return (
    <Routes>
      <Route index element={<CRMDashboardPage />} />
      <Route path="pipeline" element={<PipelinePage />} />
      <Route path="contacts" element={<ContactsPage />} />
      <Route path="activities" element={<ActivitiesPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
